import React, { Suspense, lazy } from "react";
import { useUserState } from "../../../common/UserContext";
import { isSuperAdmin } from "../../../types/UserGroup";
import { useDemoMakerFlag } from "../demoFlags";

const Panel = lazy(() =>
    import("./DemoMakerPanel").then((module) => ({ default: module.DemoMakerPanel }))
);

/**
 * Gate for the demo maker: regular users render nothing and never download
 * the panel, serializer, or player code; the chunk loads only for a
 * superadmin with the Demo Maker toggle on.
 */
export const DemoMakerMount: React.FC = () => {
    const { me } = useUserState();
    const [enabled] = useDemoMakerFlag();
    if (!enabled || !isSuperAdmin(me.roles || [])) {
        return null;
    }
    return (
        <Suspense fallback={null}>
            <Panel />
        </Suspense>
    );
};
